import axios from '../config'
import { marke_api, client_api } from '../baseURL'

export default {
    getNotes({ trainId, studentId, classId }) {
        return axios.get(`${marke_api}/note?fk_trainId=${trainId}&fk_studentId=${studentId}&fk_classId=${classId}`)
    },
    //查询笔记列表
    findList(fk_classId) {
        return axios.get(`${marke_api}/note/list?fk_classId=${fk_classId}`);
    },
    //创建或更新
    createOrUpdate(data) {
        return axios.post(`${marke_api}/note`, data);
    },
    ////////////////////////////////comment
    //创建或更新
    createComment(data) {
        return axios.post(`${marke_api}/note/comment`, data);
    },
    //清除新评论
    readComment(fk_classId, commentIdList) {
        return axios.put(`${marke_api}/note/comment/read`, { fk_classId, commentIdList });
    },
    //删除评论
    deleteComment(id, uid, commentId) {
        return axios.delete(`${marke_api}/note/comment?id=${id}&uid=${uid}&commentId=${commentId}`);
    },

    ////////////////////////////////other
    //获取用户
    getStudentUser(userGuidList) {
        return axios.post(`${client_api}/user/userlist`, { userGuidList });
    },
}